const getters = {
  sidebar: state => state.app.sidebar,
  userInfo: state => state.user.userInfo,
  permission_routers: state =>state.app.routers,
  roles: state => state.user.roles,
  routerPath: state =>state.app.routerPath,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  permissions: state => state.user.permissions
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js